/** Optional form sections must open before a validation error receives focus. */
export function revealField(element: HTMLElement | null, focus = true) {
  if (!element || element.closest("[hidden], [inert]")) return;
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    if (parent instanceof HTMLDetailsElement) parent.open = true;
  }
  if (focus) element.focus();
}
